<template>
  <svg
    version="1.1"
    id="레이어_4"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 78.8 67.9"
    style="enable-background:new 0 0 78.8 67.9;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M77.1,26.2h-8v-9c0-9.5-7.7-17.3-17.3-17.3c-9.5,0-17.3,7.7-17.3,17.3c0,0,0,0,0,0v9h-8c-0.9,0-1.7,0.7-1.8,1.7
	c0,0,0,0,0,0.1v4.1c-1.5-0.1-3-0.2-4.5-0.2c-10,0-20.2,2.7-20.2,7.9v7l0,0l0,0v6.6l0,0l0,0V60l0,0c0,5.3,10.2,8,20.2,8
	c3.5,0,7-0.3,10.4-1c0.4,0.1,0.8,0.1,1.2,0.1h39.9c3.9,0,7.1-3.2,7.1-7.1c0,0,0,0,0,0V28C78.8,27,78.1,26.2,77.1,26.2
	C77.1,26.2,77.1,26.2,77.1,26.2z M37.1,60L37.1,60c0,0.8-2.3,2.4-6.7,3.4h-0.2c-3.3,0.7-6.6,1-9.9,1c-11.1,0-16.8-3.2-16.8-4.5V58
	c3.8,2.2,10.3,3.3,16.8,3.3s13-1.1,16.8-3.3V60z M37.1,53L37.1,53c0,1.3-5.7,4.5-16.8,4.5S3.4,54.3,3.4,53v-1.6h0.1
	c3.8,2.2,10.3,3.3,16.7,3.3s13-1.1,16.8-3.3l0,0L37.1,53z M37.1,46.3L37.1,46.3c0,0.4-0.6,1.1-2,1.8c-3.1,1.7-8.8,2.7-14.9,2.7
	s-11.7-1-14.8-2.7c-1.6-0.8-2-1.5-2-1.8v-2c3.8,2.2,10.3,3.3,16.8,3.3s13-1.1,16.8-3.3L37.1,46.3z M20.2,44.3
	c-11.1,0-16.8-3.2-16.8-4.5c0-1.3,5.7-4.5,16.8-4.5c2,0,3.9,0.1,5.9,0.3h0.2c7.1,0.8,10.7,3.1,10.7,4.1
	C37.1,41.1,31.3,44.3,20.2,44.3z M45.1,17.8c-0.1-3.7,2.7-6.8,6.4-6.9c3.7-0.1,6.8,2.7,6.9,6.4c0,0.2,0,0.3,0,0.5v8.4H45.1V17.8z
	 M55.9,48.1v8.3h-8.3v-8.3c-2.4-2.3-2.4-6-0.1-8.4c2.3-2.4,6-2.4,8.4-0.1s2.4,6,0.1,8.4C56,48,56,48,55.9,48.1z"
    />
  </svg>
</template>

<script>
export default {
  name: 'StakingFillIcon',
};
</script>

<style scoped>
.st0 {
  fill: #3e0ba5;
}
</style>
